import { RootState } from '@/base/stores/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISearchResult } from './types';

export interface ISearchState {
    keyword: string;
    results?: ISearchResult[],
}

const initialState: ISearchState  = {
    keyword: '',
    results: undefined,
};

export const searchStateSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        setKeyword: (state, action: PayloadAction<string>) => {
            state.keyword = action.payload;
        },
        setResults: (state, action: PayloadAction<ISearchResult[] | undefined>) => {
            state.results = action.payload;
        }
    },
});

export const { setKeyword, setResults } = searchStateSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectKeyword = (state: RootState) => state.search.keyword;
export const selectResults = (state: RootState) => state.search.results;

export default searchStateSlice.reducer;